<div
  class="bg-white dark:bg-zinc-800 rounded-2xl shadow-sm border border-zinc-100 dark:border-zinc-700 p-6"
>
  <div class="mb-4">
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">
      {{ title }}
    </h3>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      {{ description }}
    </p>
  </div>

  <div class="flex flex-col md:flex-row gap-4 mb-4">
    <div class="flex flex-col gap-1 min-w-48">
      <label class="text-xs font-medium text-gray-600 dark:text-gray-400"
        >Usine</label
      >
      <p-select
        [options]="plantOptions"
        [(ngModel)]="selectedPlant"
        (onChange)="onPlantChange()"
        placeholder="Toutes les usines"
        [showClear]="!!selectedPlant"
        styleClass="w-full"
      />
    </div>

    <div class="flex flex-col gap-1 flex-1">
      <label class="text-xs font-medium text-gray-600 dark:text-gray-400"
        >Poste de travail</label
      >
      <p-multiselect
        [options]="mainWorkCenterOptions"
        [(ngModel)]="selectedWorkCenters"
        placeholder="Tous les postes"
        [showClear]="selectedWorkCenters.length > 0"
        [filter]="true"
        styleClass="w-full"
      />
    </div>
  </div>

  <p-button
    label="Nettoyer"
    icon="pi pi-trash"
    severity="danger"
    [loading]="isLoading"
    (click)="onClearClick()"
  />
</div>

<p-confirmDialog [key]="confirmKey" />
